import React, { useEffect, useState } from "react";
import usePreferences from "../lib/hooks/usePreferences";

function DuaCard({ dua }) {
  const { preferences } = usePreferences();
  const [localPreferences, setLocalPreferences] = useState(preferences);

  // Listen for storage changes
  useEffect(() => {
    const handleStorageChange = (e) => {
      setLocalPreferences(JSON.parse(localStorage.getItem("userPreferences")));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <div className="bg-white rounded-xl p-8 flex flex-col gap-6 relative">
      <span className="absolute -rotate-1 bg-red-600 text-white w-[42px] h-[25px] font-[ClashDisplay-Medium] font-bold -top-[10px] text-center">
        {dua.id + 1}
      </span>

      {localPreferences?.arabic?.show && (
        <p className="text-amber-900 text-center text-[24px] leading-[200%] lg:px-5 xl:px-10 px-2  font-[Scheherazade-Regular] mt-2">
          {dua.dua}
        </p>
      )}

      {localPreferences?.translation?.show && (
        <p className=" text-[#361A0A] font-[Biennale-Regular] leading-[155%]">
          {dua.translation}
        </p>
      )}

      {localPreferences?.reference?.show && (
        <p className="text-sm text-[#361A0A66] text-right -mb-3 font-[Biennale-Regular]">
          {dua.reference}
        </p>
      )}
    </div>
  );
}

export default DuaCard;
